<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">网卡管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">网卡列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- <a-range-picker :locale="locale" @change="ondateChange" /> -->
                 <a-select style="width: 120px" allowClear @change="orderhandleChange" placeholder="激活状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in orderoption" :key="x" :value="option.id">
                        {{option.title}}
                    </a-select-option>
                </a-select>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    placeholder="关键字（名称/手机/iccid）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="gdid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'customdetail',query: {id:record.id}}" >
                        {{ text }}
                    </router-link>

                    <span slot="state" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未激活</a-tag>
                        <a-tag v-if="text==1" color="green">已激活</a-tag>
                    </span>

                     <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.id)">
                        <a-icon :rotate="180"  type="phone" theme="filled"/> <span style="margin-left:3px">{{text}}</span>
                    </a>
                    <!-- <span slot="action" slot-scope="text,record">
                        <router-link :to="{path:'customdetail',query: {id:record.id}}"><a-icon type="copy"/> 详情</router-link>
                    </span> -->
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

    </div>
    
</template>

<script>
 import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
 import {formatDate} from '../../utils/formate.js'
const columns = [
    {title: 'ID',dataIndex: 'gdid',key: 'gdid',fixed: 'left'},
    {title: '客户名称',dataIndex: 'username_user',key: 'username_user'},
    {title: '号码',dataIndex:'telephone',key:'telephone'},
    {title: 'ICCID',dataIndex: 'iccid',key: 'iccid'},
    {title: '状态',dataIndex: 'state',key: 'state',scopedSlots: { customRender: 'state' }},
    {title: '客服',dataIndex: 'username_kf',key: 'username_kf'},
    // {title: '发货人',dataIndex: 'fh',key: 'fh'},

    {title: '发货日期',dataIndex: 'sendtime',key: 'sendtime',scopedSlots: { customRender: 'date' }},
    {title: '收货日期',dataIndex: 'receivtime',key: 'receivtime'},

];
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            locale,
            show:true,
            orderoption:[{title:'已激活',id:1},{title:'未激活',id:0}],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:[],
            pagination:{
                total:20
            },
            size:10,
            totalpage:2,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

            editvisible:false,
            numshow:true,
            // gjvisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            state:""
        }
    },
    watch: {
      windowHeight (val) {
        this.tablex=val-300
      },
    },
    mounted(){
        this.fetch()

        window.fullWidth = document.documentElement.clientWidth;
        this.windowWidth = window.fullWidth;  
        this.tablex=this.windowWidth-300
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                this.windowWidth = window.fullWidth;  // 高
                this.tablex=this.windowWidth-300
            })()
        };
    },
    methods:{
        onSearch(){
            this.fetch()
        },
        // 来源筛选
        lyhandleChange(){

        },

        // 标签筛选
        typehandleChange(){

        },

        // 号码查询
        handleserach(){

        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },


        // 外呼
        totel(id){

        },
        orderhandleChange(value){
            this.state=value
            this.currentpage=1
            this.fetch()
        },

        ondateChange(date, dateString) {
            console.log(date, dateString);
        },
        fetch(){
            this.$axios.post('/api/order/goodslist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
                state:this.state
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/card/cardlist.vue